import React from 'react';
import { StyleSheet, View } from 'react-native';
import CommonStyle from '../../../styles/CommonStyle';

export default function SpacerListBottom() {
    return <View style={CommonStyle("vertSpacerListBottom")} />
}
